export default {
    1: 25,
    2: 100
};